import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User generated a share link',
  name: 'Generated a share url',
  params: [
    {
      description: 'Generated share link id',
      name: 'share_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Type of object the share link was generated for',
      name: 'object_type',
      required: true,
      type: 'enum',
      values: ['clip', 'board', 'collection', 'canvas', 'asset'],
    },
    {
      description: 'Asset share link version target: current or a pinned version (v1, v2, etc.)',
      name: 'version',
      required: false,
      type: 'string',
    },
    {
      description: 'Whether file info and custom metadata are visible to viewers',
      name: 'metadata',
      required: true,
      type: 'boolean',
    },
    {
      description: 'Custom fields permission level for viewers',
      name: 'custom_fields',
      required: true,
      type: 'enum',
      values: ['hide', 'read_only', 'editable'],
    },
    {
      description: 'Comments permission level for viewers',
      name: 'comments',
      required: true,
      type: 'enum',
      values: ['hide', 'read_only', 'allow'],
    },
    {
      description: 'Whether the search input is hidden from public viewers (boards and collections only)',
      name: 'hide_search_input',
      required: false,
      type: 'boolean',
    },
    {
      description:
        'Whether viewers cannot change view type, card size, thumbnail style, and asset details visibility (boards and collections only)',
      name: 'disable_view_settings',
      required: false,
      type: 'boolean',
    },
    {
      description: 'Whether viewers cannot expand nested content (boards and collections only)',
      name: 'disable_expanding_nested',
      required: false,
      type: 'boolean',
    },
  ],
};

export default META;
